import { createContext } from "react";
import type { OneRepMaxStoreContextType } from "./OneRepMaxStoreContext.types";

const OneRepMaxContext = createContext<OneRepMaxStoreContextType | undefined>(undefined);
OneRepMaxContext.displayName = "OneRepMaxContext";

export default OneRepMaxContext;
